<template>
	<div>
		<div class="map-holder">
			<GmapMap
				v-if="cities.length"
				:center="{lat:32.100582, lng:22.989828}"
				:zoom="3"
				map-type-id="terrain"
				style="width: 100%; height: 100%"
				:options="mapStyle"
			>
				<GmapMarker
					:key="index"
					v-for="(marker, index) in markers"
					:position="{lat:marker.geopol.latitude, lng:marker.geopol.longitude}"
					:icon="pinIcon"
					@click="toggleInfoWindow(marker,index)">
				></GmapMarker>

				<gmap-info-window
					:options="infoOptions"
					:position="infoWindowPos"
					:opened="infoWinOpen"
					@closeclick="infoWinOpen=false"
				>
					<div v-html="infoContent"></div>
				</gmap-info-window>
			</GmapMap>
		</div>
		<form class="search-country-form" @submit.prevent="submitCitySearch">
			<fieldset>
				<div class="container">
					<div class="row">
						<div class="div col-12 col-md-6">
							<input-text v-model="city" name="city" type="text" placeholder="Search by city..." classes="c-input-wrapper__text--alternate"></input-text>
						</div>
						<div class="div col-12 col-md-6">
							<input-select v-model="country" placeholder="Country" :options="countryOptions" classes="c-input-wrapper__select--alternate" searchable></input-select>
						</div>
					</div>
		
					<!-- <div class="row">
						<div class="col-12">
							<input-select v-model="un_region" placeholder="or Global Region" :options="unRegions" classes="c-input-wrapper__select--alternate"></input-select>
						</div>
					</div> -->
					<div class="text-center">
						<ps-button button-style="3">Search</ps-button>
					</div>
				</div>
			</fieldset>
		</form>
	</div>
</template>

<script>
import countryOptions from '../data/countries'
import unRegions from '../data/un_regions'
import gql from 'graphql-tag'
import mapStyle from '../data/map-style'

export default {
	name: 'PsCitySearchForm',
	data: () => ({
		city: '',
		cities: [],
		country: '',
		un_region: '',
		countryOptions,
		unRegions,
		infoContent: '',
        infoWindowPos: {
			lat: 0,
			lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        //optional: offset infowindow so it visually sits nicely on top of our marker
        infoOptions: {
			maxWidth: 186,
			maxHeight: 300,
			pixelOffset: {
				width: 0,
				height: -35
			}
        },
		mapStyle,
		pinIcon: 'data:image/svg+xml;base64,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'
	}),
	apollo: {
		cities: {
			query: gql`{cities(first: 300) { 
				data {
					id, 
					name
					geopol {
						longitude
						latitude
					}
					info {
						logo
					}
				} 
			}}`,
			update: data => data.cities.data
		},
    },
	computed: {
		markers() {
			return this.cities.filter(city => {
				return city.geopol.latitude && city.geopol.longitude 
			})
		}
	},
	methods: {
		submitCitySearch() {
			let url = '/city-profiles/?city=' + this.city + '&country=' + this.country + '&un_region=' + this.un_region
			window.location.href = url
		},
		toggleInfoWindow (marker, idx) {
			this.infoWindowPos = {lat:marker.geopol.latitude, lng:marker.geopol.longitude};
			this.infoContent = this.getInfoWindowContent(marker);
			

			//check if its the same marker that was selected if yes toggle
			if (this.currentMidx == idx) {
				this.infoWinOpen = !this.infoWinOpen;
			}
			//if different marker set infowindow to open and reset current marker index
			else {
				this.infoWinOpen = true;
				this.currentMidx = idx;
			}
		},

		 getInfoWindowContent(marker) {
			var logo = marker.info.logo ?? '/wp-content/themes/cwn/assets/images/location-01.jpg';

			return (`
				<div class="">
					<div class="pin-description">
						<div class="image-holder">
							<img src="${logo}" alt="location">
						</div>
						<span>${marker.name}</span>
						<a href="/city-profiles/${marker.name}">VIEW PROFILE <i class="icon-transfer-n"></i></a>
					</div>
				</div>
				`
			);
		},
	},
	mounted() {
		// this.$axios.get('/cities')
		// .then(response => {
		// 	this.cities = response.data
		// })
		// .catch(error => {
		// 	console.log(error)
		// });
	}
}
</script>

<style lang="scss">
	.gm-style .gm-style-iw {
		background-color: transparent !important;
		top: 0 !important;
		left: 0 !important;
		padding: 0 !important;
		display: block !important;
		box-shadow: none !important;
		width: 186px !important;
		max-height: 300px !important;
	}

	.gm-style .gm-style-iw-d {
		max-height: none !important;
	}

	.gm-style .gm-style-iw-t::after {
		background: linear-gradient(45deg,#75cf70 50%,rgba(255,255,255,0) 51%,rgba(255,255,255,0) 100%) !important;
	}
</style>